import {useUrlParam} from '../../../routing'
import {useSettingsQuery} from '../../providers'

export const useLatestQuery = (plantCode?: string) => {
  const urlPlantCode = useUrlParam('plantCode')

  return useSettingsQuery('latest', [plantCode ?? urlPlantCode])
}
